import fr from 'facet-rest';
import { openModal } from 'Helpers/ModalHelper';
import { buildModalQuery } from 'Consts/ModalQueries';
import MODAL_NAMES from 'Consts/ModalNames';
import featureEnabled, { pick } from 'Helpers/Affordances';
import { APEX_ACTION_REQUIRED_STATE, APEX_SUSPENDED_STATE } from 'Consts/Apex';
import {
  buildAdvisorLink, buildClientLink, navigateToPage,
} from 'Views/Page/Content/Templates';

const handleNavigateToManagedAccount = (accountRequest, householdResource, history, isAgent) => {
  const link = accountRequest.relationship(fr.relationships.managedAccount.name).link('related').url();
  navigateToPage(link, isAgent);
};

export const handleApexAccountOnClick = (logEvent, accountRequest, householdResource, history, isAgent) => {
  logEvent('Account Creation Request: Clicked View More');

  const action = pick(accountRequest, {
    [fr.relationships.navigate.name]: () => navigateToPage(accountRequest.relationship(fr.relationships.navigate.name).link('related'), false),
  }, undefined);
  if (action) {
    action();
  }

  // If the account has a failed investigation and it is suspended or action required, open the postAccountCreation modal and return
  if (featureEnabled(accountRequest, fr.relationships.failedInvestigations.name)
    && (accountRequest.attr('status') === APEX_SUSPENDED_STATE
      || accountRequest.attr('status') === APEX_ACTION_REQUIRED_STATE)) {
    openModal(
      buildModalQuery(MODAL_NAMES.postAccountCreation, {
        accountCreationRequestLink: accountRequest.link('self').url(),
      }),
    );

    return;
  }

  // If the account has a managed account page
  if (accountRequest.relationship(fr.relationships.managedAccountPage.name)) {
    const linkURL = accountRequest.relationship(fr.relationships.managedAccountPage.name).link('related').url();
    const advisorUri = buildAdvisorLink(linkURL, { link: linkURL });
    const clientUri = buildClientLink(linkURL, { link: linkURL });
    const uri = isAgent ? advisorUri : clientUri;
    history.push(uri);
    return;
  }

  // If the account has a managed account, navigate to the managed account page and return
  if (accountRequest.relationship(fr.relationships.managedAccount.name)) {
    handleNavigateToManagedAccount(accountRequest, householdResource, history, isAgent);
  }
};
